import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgSignal = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM10.012 15.866c-.912 1.034-.4 6.021.412 6.944.811.92 2.34.92 3.152 0 .813-.923 1.324-5.91.412-6.944-1.017-1.155-2.96-1.155-3.976 0Zm2.476 1.322c.028.032.042.15.045.328l-.003.31-.017.38-.029.43-.06.695-.05.468-.055.449-.057.409-.057.349c-.047.26-.092.439-.13.482-.014.016-.136.016-.15 0-.038-.043-.083-.221-.13-.482l-.057-.35-.057-.408-.054-.449-.05-.468-.043-.468-.034-.448-.023-.407a11.936 11.936 0 0 1-.007-.182l-.003-.31c.003-.178.017-.296.045-.328.199-.226.651-.248.9-.068l.076.068Z" />
      <path d="M12 4.5a6.5 6.5 0 0 1 4.117 11.53 1 1 0 1 1-1.267-1.547 4.5 4.5 0 1 0-5.7 0 1 1 0 0 1-1.267 1.547A6.5 6.5 0 0 1 12 4.5Z" />
      <path d="M12 1c5.523 0 10 4.477 10 10a10 10 0 0 1-5.596 8.98 1 1 0 0 1-.882-1.795 8 8 0 1 0-7.044 0 1 1 0 0 1-.882 1.795A10 10 0 0 1 2 11C2 5.477 6.477 1 12 1Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgSignal)
const Memo = memo(ForwardRef)
export default Memo
